<template>
  <div class="practice-result-page">
    <div class="top-nav">
      <span class="back-link" @click="backToErrorNotes">{{ backText }}</span>
      <i class="el-icon-arrow-right"></i>
    </div>

    <div class="score-area">
      <div class="score-circle">
        <svg class="progress-ring" viewBox="0 0 100 100" :style="{ strokeDasharray: ringCircumference, strokeDashoffset: ringOffset }">
          <circle class="ring-track" cx="50" cy="50" r="40" />
          <circle class="ring-progress" cx="50" cy="50" r="40" :stroke="ringColor" />
        </svg>
        <img class="bg-time" :src="bgTime" alt="" />
        <img class="purple-circle" :src="purpleCircle" alt="" />
        <div class="score-text">{{ displayRate + '%' }}</div>
        <div class="score-sub">正确率</div>
      </div>
    </div>

    <div class="title">{{ isWrongPractice ? '错题练习' : (source === 'studyLearn' || source === 'lesson' || source === 'practice' ? '练习结果' : '考试结果') }}</div>
    <div class="user">
      <el-avatar :size="32">{{ avatarText }}</el-avatar>
      <span class="name">{{ displayName }}</span>
    </div>

    <div class="stats-card">
      <div class="stat">
        <div class="val">{{ total }}</div>
        <div class="label">题目数</div>
      </div>
      <div class="stat">
        <div class="val">{{ wrong }}</div>
        <div class="label">错题数</div>
      </div>
      <div class="stat">
        <div class="val">{{ unanswered }}</div>
        <div class="label">未答数</div>
      </div>
    </div>

    <div v-if="shouldShowDetails && detailedResults.length" class="details-card">
      <div class="details-title">答题详情</div>
      <div v-for="(q, i) in detailedResults" :key="q.id || i" class="detail-item">
        <div class="detail-header">
          <span class="detail-index">{{ i + 1 }}.</span>
          <span class="detail-status" :class="{ correct: q.isCorrect, wrong: !q.isCorrect }">
            {{ q.isCorrect ? '正确' : '错误' }}
          </span>
        </div>
        <div v-if="q.content" class="detail-question">{{ q.content }}</div>
        <div class="detail-row">
          <span class="k">你的答案：</span>
          <span class="v">{{ formatAnswer(q.userAnswer) }}</span>
        </div>
        <div v-if="!hideCorrectAnswer" class="detail-row">
          <span class="k">正确答案：</span>
          <span class="v">{{ formatAnswer(q.correctAnswer, '-') }}</span>
        </div>
      </div>
    </div>

    <div class="actions">
      <!-- <el-button type="primary" class="retry-btn" @click="retry">再次答题</el-button> -->
    </div>

    <div class="bg bg1"></div>
    <div class="bg bg2"></div>
    <div class="bg bg3"></div>
  </div>
</template>

<script>
export default {
  name: 'ExamSubmitResult',
  computed: {
    source() {
      return this.$route.query.source || ''
    },
    courseId() {
      return this.$route.query.courseId
    },
    sectionId() {
      return this.$route.query.sectionId
    },
    isWrongPractice() {
      return this.$route.query.mode === 'wrongPractice'
    },
    isExam() {
      return this.source === 'exam'
    },
    isPractice() {
      return this.source === 'practice'
    },
    paperType() {
      return Number(this.$route.query.paperType || 0)
    },
    isSimulationOrPractice() {
      return this.paperType === 2 || this.paperType === 3 || this.paperType === 4
    },
    shouldShowDetails() {
      const showScore = Number(this.$route.query.showScore ?? 1)
      return showScore === 1 && !this.isSimulationOrPractice
    },
    hideCorrectAnswer() {
      const v = this.$route.query.hideCorrectAnswer
      return v === true || v === 1 || v === '1' || v === 'true'
    },
    actualScore() {
      return Number(this.$route.query.actualScore || 0)
    },
    totalScore() {
      return Number(this.$route.query.totalScore || 100)
    },
    passScore() {
      return Number(this.$route.query.passScore || 60)
    },
    hasPassedStatus() {
      const val = this.$route.query.isPassed
      return val !== undefined && val !== null && val !== ''
    },
    isPassed() {
      const val = this.$route.query.isPassed
      if (val === undefined || val === null || val === '') return null
      return val === true || val === 1 || val === '1' || val === 'true'
    },
    backText() {
      if (this.source === 'studyLearn' || this.source === 'lesson') return '返回学习'
      if (this.source === 'practice') return '返回模拟练习'
      if (this.isExam) return '返回我的考试'
      return '返回错题库'
    },
    correctCount() {
      const raw = this.$route.query.correctCount
      return Number(raw || 0)
    },
    displayRate() {
      if (this.total <= 0) return 0
      if (this.correctCount > 0) {
        return Math.min(100, Math.max(0, Math.round((this.correctCount / this.total) * 100)))
      }
      const rate = Number(this.$route.query.correctRate || 0)
      return Math.min(100, Math.max(0, Math.round(rate)))
    },
    total() {
      return Number(this.$route.query.total || 0)
    },
    wrong() {
      return Number(this.$route.query.wrong || 0)
    },
    unanswered() {
      return Number(this.$route.query.unanswered || 0)
    },
    practiceId() {
      return this.$route.query.practiceId
    },
    bgTime() {
      return require('@/assets/image/bg_time.png')
    },
    purpleCircle() {
      return require('@/assets/image/icon_purple_circle.png')
    },
    ringCircumference() {
      const r = 40
      return 2 * Math.PI * r
    },
    ringOffset() {
      return this.ringCircumference * (1 - this.displayRate / 100)
    },
    ringColor() {
      if (this.isExam && this.hasPassedStatus && this.isPassed === false) return '#ff4d4f'
      return '#3E2CCD'
    },
    displayName() {
      const store = this.$store
      const loggedIn = store && store.getters && store.getters['auth/isLoggedIn']
      if (!loggedIn) return '未登录'
      const username = store.getters['auth/username']
      const info = store.getters['auth/userInfo'] || {}
      return username || info.mobile || info.phone || info.nickname || '用户'
    },
    avatarText() {
      const name = this.displayName || ''
      return name ? String(name).trim().slice(0, 1) : 'U'
    },
    detailedResults() {
      const raw = this.$route.query.results
      if (!raw) return []
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    formatAnswer(val, emptyText = '未答') {
      if (val == null) return emptyText
      if (Array.isArray(val)) {
        const s = val.join('、').trim()
        return s ? s : emptyText
      }
      const s = String(val).trim()
      return s ? s : emptyText
    },
    backToErrorNotes() {
      if (this.isExam) {
        this.$router.push('/member-center/exams')
        return
      }
      const returnPath = this.$route.query.returnPath
      if (returnPath) {
        this.$router.push(returnPath)
        return
      }
      if (this.source === 'studyLearn' || this.source === 'lesson') {
        this.$router.back()
        return
      }
      if (this.source === 'practice') {
        this.$router.push('/member-center/simulation')
        return
      }
      this.$router.push('/error-notes')
    },
    retry() {
      if (this.source === 'lesson') {
        this.$router.back()
        return
      }
      if (this.source === 'studyLearn') {
        const id = this.courseId || 1
        this.$router.push({
          name: 'learn',
          params: { id },
          query: { openQuiz: '1', sectionId: this.sectionId || '' }
        })
        return
      }
      if (this.isExam) {
        const id = this.$route.query.paperId
        if (id) {
          const q = {}
          const mode = this.$route.query.mode
          q.mode = mode || 'exam'
          const title = this.$route.query.title
          if (title) q.title = title
          const duration = this.$route.query.duration
          if (duration != null && duration !== '') q.duration = duration
          const totalScore = this.$route.query.totalScore
          if (totalScore != null && totalScore !== '') q.totalScore = totalScore
          const passScore = this.$route.query.passScore
          if (passScore != null && passScore !== '') q.passScore = passScore
          const returnPath = this.$route.query.returnPath
          if (returnPath) q.returnPath = returnPath
          this.$router.push({ path: `/exam-intro/${id}`, query: q })
        } else {
          this.$router.back()
        }
        return
      }
      if (this.source === 'practice') {
        const id = this.practiceId || 1
        this.$router.push({ path: `/practice-detail/${id}` })
        return
      }
      const id = this.practiceId || 1
      this.$router.push({ path: `/practice-detail/${id}`, query: { mode: 'wrongPractice' } })
    }
  }
}
</script>

<style lang="scss" scoped>
.practice-result-page {
  min-height: 100vh;
  background: #fff;
  position: relative;
  padding: 40px 20px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-nav {
  width: 100%;
  max-width: 900px;
  text-align: right;
  color: #606266;
  margin-bottom: 10px;

  .back-link { cursor: pointer; }
}

.score-area { margin-top: 10px; }

.score-circle {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(124,58,237,0.25);
}

.score-text { color: #fff; font-size: 44px; font-weight: 800; z-index: 4; }
.score-sub { position: absolute; bottom: 64px; color: #fff; font-size: 14px; z-index: 4; }

.progress-ring {
  position: absolute; 
  inset: 0; 
  transform: rotate(90deg)  scale(-1, 1);
  z-index: 1; 
  width: 100%; 
  height: 100%; 
}
.ring-track { fill: none; stroke: #eaeaf2; stroke-width: 20; }
.ring-progress { fill: none; stroke: #722ed1; stroke-width: 20; stroke-linecap: round; transition: stroke-dashoffset 0.4s ease; }

.bg-time {
  position: absolute; 
  left: 50%; 
  top: 50%; 
  transform: translate(-50%, -50%); 
  border-radius: 50%; 
  object-fit: cover; 
  width: 200px;
  height: 200px;
  z-index: 2; 
}

.purple-circle {

  position: absolute;
  left: 50%; 
  top: 50%; 
  transform: translate(-50%, -50%); 
  border-radius: 50%; 
  object-fit: cover; 
  width: 140px;
  height: 140px;
  z-index: 3; 
}

.title { margin-top: 18px; font-size: 20px; font-weight: 600; color: #5b21b6; }
.user { margin-top: 6px; display: flex; align-items: center; gap: 8px; color: #606266; }

.stats-card {
  margin-top: 20px;
  display: flex;
  background: #f5f7fa;
  border-radius: 12px;
  overflow: hidden;
}

.stat { padding: 18px 40px; text-align: center; }
.stat .val { font-size: 24px; font-weight: 700; color: #303133; }
.stat .label { font-size: 12px; color: #909399; }

.actions { margin-top: 28px; width: 640px; max-width: 90%; }
.retry-btn { width: 100%; background-color: #5b21b6; border-color: #5b21b6; }
.retry-btn:hover { background-color: #4c1d95; border-color: #4c1d95; }

.details-card {
  margin-top: 18px;
  width: 900px;
  max-width: 100%;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 14px 16px;
  box-sizing: border-box;
}

.details-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.detail-item {
  padding: 12px 0;
  border-top: 1px solid #f0f0f0;
}

.detail-item:first-of-type {
  border-top: none;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.detail-index {
  font-weight: 600;
  color: #303133;
}

.detail-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #f4f4f5;
  color: #606266;
}

.detail-status.correct {
  background: #f0f9eb;
  color: #67c23a;
}

.detail-status.wrong {
  background: #fef0f0;
  color: #f56c6c;
}

.detail-question {
  color: #303133;
  line-height: 1.6;
  margin-bottom: 8px;
}

.detail-row {
  display: flex;
  gap: 8px;
  line-height: 1.8;
}

.detail-row .k { color: #909399; }
.detail-row .v { color: #303133; }

.bg { position: absolute; background: url('@/assets/image/bg_time.png') center/contain no-repeat; opacity: 0.12; }
.bg1 { left: 40px; top: 160px; width: 120px; height: 120px; }
.bg2 { right: 120px; top: 280px; width: 180px; height: 180px; }
.bg3 { right: 60px; top: 100px; width: 60px; height: 60px; }
</style>
